<template>
  <div>
    <div :class="{ hidden: !sidebar }" class="fixed inset-0 flex z-40 xl:hidden" role="dialog" aria-modal="true">
      <div @click.self="sidebar = false" class="fixed inset-0 bg-gray-600 bg-opacity-75" aria-hidden="true"></div>
      <div class="relative flex-1 flex flex-col max-w-xs w-full bg-white">
        <div class="absolute top-0 right-0 -mr-12 pt-2">
          <button
            @click="sidebar = false"
            type="button"
            class="ml-1 flex items-center justify-center h-10 w-10 rounded-full focus:outline-none focus:ring-2 focus:ring-inset focus:ring-white"
          >
            <span class="sr-only">Close sidebar</span>
            <!-- Heroicon name: outline/x -->
            <svg
              class="h-6 w-6 text-white"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              aria-hidden="true"
            >
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>

        <div class="flex-1 h-0 pt-5 pb-4 overflow-y-auto">
          <div class="flex-shrink-0 flex items-center px-4">
            <div class="flex items-center flex-shrink-0 text-2xl font-bold tet">Angelo Ferraro</div>
          </div>
          <nav class="mt-5 px-2 space-y-1">
            <router-link
              v-for="item in navigation"
              :key="item.label + JSON.stringify(item.counters)"
              :to="item.to"
              class="hover:bg-gray-100 text-gray-800 group flex items-center px-2 py-2 text-sm font-medium rounded-l-md"
              :class="{ 'font-bold bg-gray-100 hover:bg-gray-200 text-gray-900': route.name === item.routeName }"
            >
              <i
                :class="{
                  [item.icon || 'fas fa-home']: true,
                  'text-indigo-500 group-hover:text-indigo-700': route.name === item.routeName,
                  'text-gray-400 group-hover:text-gray-500': route.name !== item.routeName,
                }"
                class="text-xl w-18 inline-block"
              ></i>
              {{ item.label }}
              <label v-for="(counter, index) in item.counters" :key="`${index}-${counter.count}`">
                {{ counter.count }}
              </label>
            </router-link>
          </nav>
        </div>
        <div class="flex-shrink-0 flex border-t border-gray-200 p-4">
          <router-link to="/settings" class="flex-shrink-0 group block">
            <div class="flex items-center">
              <div>
                <div class="rounded-full h-8 w-8 bg-indigo-200 text-indigo-800 flex justify-center items-center">
                  AF
                </div>
              </div>
              <div class="ml-3">
                <p class="text-sm font-medium text-gray-700 group-hover:text-gray-900 mb-0">Angelo Ferraro</p>
                <span class="text-xs font-medium text-gray-500 group-hover:text-gray-700 pl-1 inline-block">
                  <i class="fas fa-cogs"></i> Settings
                </span>
              </div>
            </div>
          </router-link>
        </div>
      </div>

      <div class="flex-shrink-0 w-14">
        <!-- Force sidebar to shrink to fit close icon -->
      </div>
    </div>

    <!-- Static sidebar for desktop -->
    <div class="hidden xl:flex xl:w-64 xl:flex-col xl:fixed xl:inset-y-0 text-gray-900">
      <!-- Sidebar component, swap this element with another sidebar if you like -->
      <div class="flex-1 flex flex-col min-h-0 border-r border-gray-200 bg-white">
        <div class="flex-1 flex flex-col pt-5 pb-4 overflow-y-auto">
          <div class="flex items-center flex-shrink-0 px-4 text-2xl font-bold tet">Angelo Ferraro</div>
          <nav class="mt-5 flex-1 px-2 bg-white space-y-1">
            <router-link
              v-for="item in navigation"
              :key="item.label + JSON.stringify(item.counters)"
              :to="item.to"
              class="hover:bg-gray-100 text-gray-800 group flex items-center justify-between px-2 py-2 text-sm font-medium rounded-l-md"
              :class="{ 'font-bold bg-gray-100 hover:bg-gray-200 text-gray-900': route.name === item.routeName }"
            >
              <span class="flex flex-row items-center justify-center whitespace-nowrap">
                <i
                  :class="{
                    [item.icon || 'fas fa-home']: true,
                    'text-indigo-500 group-hover:text-indigo-700': route.name === item.routeName,
                    'text-gray-400 group-hover:text-gray-500': route.name !== item.routeName,
                  }"
                  class="text-xl w-9 inline-block"
                ></i>
                {{ item.label }}
              </span>

              <div class="flex flex-row gap-1">
                <label
                  v-for="(counter, index) in item.counters"
                  :key="`${index}-${counter.count}`"
                  class="w-7 h-7 flex justify-center items-center text-xs rounded text-white"
                  :class="counter.class"
                >
                  {{ counter.count }}
                </label>
              </div>
            </router-link>
          </nav>
        </div>
        <div class="flex-shrink-0 flex border-t border-gray-200 p-4">
          <router-link to="/settings" class="flex-shrink-0 w-full group block">
            <div class="flex items-center">
              <div>
                <div class="rounded-full h-8 w-8 bg-indigo-200 text-indigo-800 flex justify-center items-center">
                  AF
                </div>
              </div>
              <div class="ml-3">
                <p class="text-sm font-medium text-gray-700 group-hover:text-gray-900 mb-0">Angelo Ferraro</p>
                <span class="text-xs font-medium text-gray-500 group-hover:text-gray-700 pl-1 inline-block">
                  <i class="fas fa-cogs"></i> Settings
                </span>
              </div>
            </div>
          </router-link>
        </div>
      </div>
    </div>

    <div class="xl:pl-64 flex flex-col flex-1">
      <div class="sticky top-0 z-10 xl:hidden pl-1 pt-1 sm:pl-3 sm:pt-3 bg-white">
        <button
          type="button"
          @click="sidebar = true"
          class="-ml-0.5 -mt-0.5 h-12 w-12 inline-flex items-center justify-center rounded-md text-gray-500 hover:text-gray-900 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-indigo-500"
        >
          <span class="sr-only">Open sidebar</span>
          <svg
            class="h-6 w-6"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            aria-hidden="true"
          >
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16M4 12h16M4 18h16" />
          </svg>
        </button>
      </div>
      <main class="flex-1 bg-gray-100" style="min-height: 100vh">
        <div class="py-6">
          <div class="max-w-7xl mx-auto px-4 sm:px-6 md:px-8 mb-12 flex justify-between" :key="route.name">
            <div>
              <h1 class="text-2xl font-semibold text-gray-900">{{ theme.title || ' ' }}</h1>
              <p class="mt-1 text-sm text-gray-500" v-if="theme.subtitle">
                {{ theme.subtitle }}
              </p>
            </div>
            <UISelectClient
              v-if="!routeMeta.hideClientSearch"
              placeholder="Chercher un client..."
              v-model="searchedClient"
            />
            <div v-if="theme.buttons?.length">
              <!-- inline-flex items-center px-4 py-2 border border-gray-300 rounded-md shadow-sm text-sm font-medium text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 -->
              <router-link
                class="ml-3 inline-flex items-center px-4 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                v-for="(btn, index) in theme.buttons"
                :key="index"
                :to="btn.to || '/'"
              >
                {{ btn.label }}
              </router-link>
            </div>
          </div>
          <div class="max-w-7xl mx-auto px-4 sm:px-6 md:px-8">
            <!-- Replace with your content -->
            <slot></slot>
            <!-- /End replace -->
          </div>
        </div>
      </main>
    </div>
  </div>
</template>

<script setup>
import { computed, onMounted, ref, watch } from 'vue'
import navigation from '@/router/main-navigation'
import { useRoute, useRouter } from 'vue-router'
import { useStore } from 'vuex'
import UISelectClient from '@/components/UI/Molecule/SelectClient'

const sidebar = ref(true)
const route = useRoute()
const router = useRouter()
const store = useStore()
const searchedClient = ref(null)

watch(searchedClient, val => {
  if (val && val.id) {
    router.push(`/clients/${val.id}`)
  }
})

const routeMeta = computed(() => {
  return route.meta || {}
})

const theme = computed(() => {
  const matched = route.matched || []
  return matched.reduce((prev, meta) => {
    const val = meta?.components?.default?.theme
    if (val) {
      let result
      const isFunction = typeof val === 'function'
      if (isFunction) result = val({ route, store })
      else result = val
      return Object.assign({}, prev, result || {})
    }
    return prev
  }, {})
})

onMounted(() => {
  store.commit('GET_COUNTERS')
})
</script>

<style lang="scss"></style>
